import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Card from "@mui/material/Card";
import { Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { API_URL } from "url";
import { setAuthSession, getDefaultRouteForScope } from "utils/auth";

function HRSignIn() {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    setUser((prev) => ({ ...prev, [fieldName]: fieldValue }));
  };

  const submitData = async (event) => {
    event.preventDefault();

    if (!user.email || !user.password) {
      setError("Fill all fields");
      return;
    }

    setError("");
    setSubmitButtonDisabled(true);

    try {
      const response = await fetch(`${API_URL}/hr-auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      });

      const data = await response.json();

      if (data.success) {
        const targetRoute = getDefaultRouteForScope("hr");
        setAuthSession({
          token: data.accessToken,
          user: data?.data?.email,
          scope: "hr",
          role: data?.data?.role,
        });
        navigate(targetRoute);
        window.location.href = targetRoute;
      } else {
        setError(data?.message || "Invalid HR credentials");
      }
    } catch (fetchError) {
      setError("Unable to sign in right now");
      console.error("HR login error:", fetchError);
    } finally {
      setSubmitButtonDisabled(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="success"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            HR Sign in
          </MDTypography>
          <MDTypography variant="button" color="white" opacity={0.8}>
            Access HR-only payslip tools
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <input
                type="email"
                className="form-control"
                placeholder="HR Email"
                style={{ height: "50px" }}
                name="email"
                value={user.email}
                onChange={handleChange}
              />
            </MDBox>
            <MDBox mb={2}>
              <input
                type="password"
                placeholder="Password"
                className="form-control"
                style={{ height: "50px" }}
                name="password"
                value={user.password}
                onChange={handleChange}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="success"
                fullWidth
                onClick={submitData}
                disabled={submitButtonDisabled}
              >
                HR Sign in
              </MDButton>
            </MDBox>
            <MDBox mt={2} textAlign="center">
              <Link to="/" aria-label="go to admin login page">
                <Typography sx={{ fontSize: "14px" }}>Back to admin sign in</Typography>
              </Link>
            </MDBox>
            <MDBox mt={2} mb={1}>
              <p style={{ color: "red" }}>{error}</p>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default HRSignIn;
